module.exports = __webpack_public_path__ + "img/9.52751a53.png";